import { z } from 'zod';
import type { GetShortCourseDto } from '../types/GetShortCourseDto';

export const getShortCourseDtoSchema = z.object({
  id: z.string().uuid(),
  title: z.string().min(3).max(255),
  description: z.string().min(3).max(255).nullable(),
  numberOfCards: z.number(),
}) as z.ZodType<GetShortCourseDto>;
